const maxValue = 1000;
export const STRING_MAX_VALIDATION = {
  value: maxValue,
  message: `Sono stati inseriti più di ${maxValue} caratteri`,
};
